/**
 * The cities with a guide, on the map: used only to tell whether a signed job was in the city of the move. Bengaluru's
 * centre is Majestic (Kempegowda bus station); 30 km covers the city corporation and its edges (Whitefield, Kengeri).
 */
export const CITY_AREA = {
    bengaluru: { centre: { lat: 12.9767, lon: 77.5713 }, radius_km: 30 },
};
//# sourceMappingURL=cities.js.map